import React, {useRef, useEffect, useState} from 'react'
import CircularProgressRing from './AlarmAnimatedCircleProgress'
import { Segments, AlarmData } from '../Alarm Functions/AlarmOverviewFunctions'
import {gsap } from 'gsap'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';



interface Props {
    segData: Segments
    currentPage: number
    tempAlarm: AlarmData | null
    editAlarm: boolean
    handlePageChange: (num : number) => void
}

const AlarmSetProgressBar: React.FC<Props> = ({ segData,  currentPage, tempAlarm, editAlarm, handlePageChange }) => {


    const intl:IntlShape = useIntl()

    const numberOfSegments = {
        page1: 2,
        page2: tempAlarm?.type === 'digital' ? 2: 5,
        page3: 2,
        page4: 1
    }

    const progressBar1Ref = useRef<HTMLDivElement>(null)
    const progressBar2Ref = useRef<HTMLDivElement>(null)
    const progressBar3Ref = useRef<HTMLDivElement>(null)
    const animatedCircle2Ref = useRef<HTMLDivElement>(null)
    const animatedCircle3Ref = useRef<HTMLDivElement>(null)
    const animatedCircle4Ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const progressBar1 = progressBar1Ref?.current
        const progressBar2 = progressBar2Ref?.current
        const progressBar3 = progressBar3Ref?.current
        const animatedCircle2 = animatedCircle2Ref?.current
        const animatedCircle3 = animatedCircle3Ref?.current
        const animatedCircle4 = animatedCircle4Ref?.current

        const timing = editAlarm ? 0.02 : 0.3
        const tl = gsap.timeline()
        if (currentPage === 2 || editAlarm) {
            tl.to(progressBar1, {
                height: 67,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(animatedCircle2, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
            if (!tempAlarm?.count && !tempAlarm?.clearCount) {
                tl.to(animatedCircle3, {
                    opacity: 0,
                    scale: 0,
                    duration: timing,
                    ease: 'power2.out'
                })
                tl.to(progressBar2, {
                    height: 0,
                    duration: timing,
                    ease: 'power2.out'
                })
            }
        }
        
        if (currentPage === 3 || editAlarm) {
            tl.to(progressBar1, {
                height: 67,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(animatedCircle2, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
            if (tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'analogDropOut') {
                tl.to(progressBar2, {
                    height: 67,
                    duration: timing,
                    ease: 'power2.out'
                })
            }
            tl.to(animatedCircle3, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
        }
        if (currentPage === 4 || editAlarm) {
            tl.to(progressBar1, {
                height: 67,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(animatedCircle2, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
            console.log(tempAlarm.type, progressBar2)
            if (tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'analogDropOut') {
                tl.to(progressBar2, {
                    height: 67,
                    duration: timing,
                    ease: 'power2.out'
                })
            }
            tl.to(animatedCircle3, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(progressBar3, {
                height: 67,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(animatedCircle4, {
                opacity: 1,
                scale: 1,
                duration: timing,
                ease: 'power2.out'
            })
        }

        ///reverse

        if (currentPage === 1 && !tempAlarm?.condition) {
            if (skipSettingConditions && skipSettingCount) {
                tl.to(progressBar3, {
                    height: 0,
                    duration: timing,
                    ease: 'power2.out'
                })
            }
            tl.to(progressBar1, {
                height: 0,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(animatedCircle4, {
                opacity: 0,
                scale: 0,
                duration: timing,
                ease: 'power2.out'
            })
            tl.to(progressBar3, {
                height: 0,
                duration: timing,
                ease: 'power2.out'
            })
        }

        if (currentPage === 3 && !tempAlarm?.message) {
            if (!skipSettingCount) {
                tl.to(animatedCircle4, {
                    opacity: 0,
                    scale: 0,
                    duration: timing,
                    ease: 'power2.out'
                })
                tl.to(progressBar3, {
                    height: 0,
                    duration: timing,
                    ease: 'power2.out'
                })
            }
        }
        ///reset animation on new alarm
        if (currentPage === 1 && !tempAlarm?.type) {
            tl.set([progressBar1, progressBar2, progressBar3], {
                height: 0,
            })
            tl.set([animatedCircle2, animatedCircle3, animatedCircle4], {
                opacity: 0,
                scale: 0,
            }, '<')

        }
    }, [currentPage, tempAlarm])


    useEffect(() => {
        const skipStep2And3Types = ['noData', 'analogDropOut']
        if (skipStep2And3Types.includes(tempAlarm?.type)) {
            setSkipSettingConditions(true)
            setSkipSettingCount(true)
        } else if (tempAlarm?.type === 'consumption' || tempAlarm?.type === 'digital') {
            setSkipSettingCount(true)
        } else {
            setSkipSettingConditions(false)
            setSkipSettingCount(false)
        }
    },[tempAlarm])

    const [skipSettingConditions, setSkipSettingConditions] = useState<boolean>(false)
    const [skipSettingCount, setSkipSettingCount] = useState<boolean>(false)





    
    
    return (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
            {console.log(tempAlarm.type) }
            <div style={{ width: '80%', position: 'relative', marginTop: 20 }}>
                {/*progress bar animation*/}
                <div style={{ width: '5%', position: 'absolute', left: 0 }}>

                    {/*Circle 1*/ }
                    <div
                        style={{ zIndex: 20, position: 'relative', cursor: 'pointer' }}
                        onClick={(): void => handlePageChange(1)}
                    >
                        <CircularProgressRing activeSegments={segData.page1.num} numberOfSegments={numberOfSegments.page1} />
                    </div>

                    {/*Line 1*/}
                    <div ref={progressBar1Ref} style={{ backgroundColor: '#00BF00', width: 10, height: 0, position: 'absolute', top: 28, left: 11, zIndex: 1 }}></div>
                    {/*Circle 2*/}
                    {!skipSettingConditions &&
                        <div
                            style={{ marginTop: 60, zIndex: 20, position: 'relative', opacity: 0, scale: 0, cursor: 'pointer' }}
                            ref={animatedCircle2Ref}
                            onClick={(): void => handlePageChange(2)}
                        >
                            {(tempAlarm?.condition || currentPage > 1) &&
                                <CircularProgressRing activeSegments={segData.page2.num} numberOfSegments={numberOfSegments.page2} />
                            }
                        </div>
                    }

                    {/*Line 2*/}
                    <div ref={progressBar2Ref} style={{ backgroundColor: '#00BF00', width: 10, height: 0, position: 'absolute', top: 120, left: 11, zIndex: 1 }}></div>

                    {/*Circle 3*/}
                    {!skipSettingConditions && !skipSettingCount &&
                        <div
                            style={{ marginTop: 60, zIndex: 20, position: 'relative', opacity: 0, scale: 0, cursor: 'pointer' }}
                            ref={animatedCircle3Ref}
                            onClick={(): void => handlePageChange(3)}
                        >
                            {(tempAlarm?.condition || currentPage > 2) &&
                                <CircularProgressRing activeSegments={segData.page3.num} numberOfSegments={numberOfSegments.page3} />
                            }
                        </div>
                    }

                    {/*Line 3*/}
                    <div ref={progressBar3Ref} style={{
                        backgroundColor: '#00BF00',
                        width: 10,
                        height: 0,
                        position: 'absolute',
                        top: tempAlarm?.type === 'noData' || tempAlarm?.type === 'analogDropOut' ?
                            28 :
                            tempAlarm?.type === 'consumption' || tempAlarm?.type === 'digital' ?
                                120 :
                                211,
                        left: 11,
                        zIndex: 1
                    }}></div>

                    {/*Circle 4*/}
                    <div
                        style={{ marginTop: 60, zIndex: 20, position: 'relative', opacity: 0, scale: 0, cursor: 'pointer' }}
                        ref={animatedCircle4Ref}
                        onClick={(): void => handlePageChange(4)}
                    >
                        {(tempAlarm?.condition || currentPage > 3) &&
                            <CircularProgressRing activeSegments={segData.page4.num} numberOfSegments={numberOfSegments.page4} />
                        }
                    </div>
                </div>


                {/* text  title */}
                <div style={{ width: '50%', position: 'absolute', left: '5%', margin: '5px 0 0 10px' }}>
                    <p
                        style={{
                            margin: '0 0 0 10px',
                            fontWeight: currentPage === 1 ? 800 : 'inherit',
                            cursor: 'pointer'
                        }}
                        onClick={(): void => handlePageChange(1)}
                    >
                        <b>
                            <FormattedMessage id="Type / Channel"/>:
                        </b>
                    </p>



                    {tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'analogDropOut' &&
                        <div
                            style={{
                                marginTop: 67
                            }}
                        >
                            {(tempAlarm?.condition || currentPage > 1) &&
                                <p style={{
                                    margin: '7px 0 0 10px',
                                    fontWeight: currentPage === 2 ? 800 : 'inherit',
                                    cursor: 'pointer'
                                }}
                                    onClick={(): void => handlePageChange(2)}
                                >
                                    <b>
                                        <FormattedMessage id="Conditions"/>:
                                    </b>
                                </p>
                            }
                        </div>
                    }



                    {tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'consumption' && tempAlarm?.type !== 'analogDropOut' && tempAlarm?.type !== 'digital' &&
                        <div style={{
                            marginTop: 67
                        }}
                        >
                            {(tempAlarm?.count || currentPage > 2) &&
                                <p style={{
                                    margin: '7px 0 0 10px',
                                    fontWeight: currentPage === 3 ? 800 : 'inherit',
                                    cursor: 'pointer'
                                }}
                                    onClick={(): void => handlePageChange(3)}
                                >
                                    <b>
                                        <FormattedMessage id="Triggers"/>:
                                    </b>
                                </p>
                            }
                        </div>
                    }

                    <div
                        style={{ marginTop: 67 }}
                    >
                        {(tempAlarm?.message || currentPage > 3) &&
                            <p style={{
                                margin: '0 0 0 10px',
                                fontWeight: currentPage === 4 ? 800 : 'inherit',
                                cursor: 'pointer'
                            }}
                                onClick={(): void => handlePageChange(4)}
                            >
                                <b>
                                    <FormattedMessage id="Message / Contact / Timeframe" />:
                                </b>
                            </p>
                        }
                    </div>
                </div>

                {/*text vars*/}
                <div style={{ width: '45%', position: 'absolute', left: '55%', margin: '5px 0 0 10px' }}>
                    <p>{segData.page1.text}</p>
                    {tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'analogDropOut' &&<div style={{ marginTop: 57 }}>
                        {(tempAlarm?.condition || currentPage > 1) &&
                            <p style={{ marginTop: '4px' }}>
                                {tempAlarm?.condition ? `${intl.formatMessage({ id: 'Set' })}: ${segData.page2.text[0]}` : ''} <br />
                                {(tempAlarm?.clearCondition || tempAlarm?.consumptionTimeframe) ?
                                    !tempAlarm?.consumptionTimeframe ? `Clear: ${segData.page2.text[1]}` :
                                        `${intl.formatMessage({ id: 'Timeframe' })} : ${segData.page2.text[1]}` : ''}
                            </p>
                        }
                    </div>}
                    {tempAlarm?.type !== 'noData' && tempAlarm?.type !== 'analogDropOut' && tempAlarm?.type !== 'digital' && tempAlarm?.type !== 'consumption' && <div style={{ marginTop: 43 }}>
                        {(tempAlarm?.count || currentPage > 2) && <p style={{ marginTop: '4px' }}>{tempAlarm?.count ? `${intl.formatMessage({ id: 'Trigger Count' })} : ${segData.page3.text[0]}` : ''} <br /> {tempAlarm?.clearCount ? `${intl.formatMessage({ id: 'Clear Count' })} : ${segData.page3.text[1]}` : ''} </p>}
                    </div>}
                    <div style={{ marginTop: tempAlarm?.type === 'noData' || tempAlarm?.type === 'analogDropOut' ? 68 : tempAlarm?.type === 'digital' || tempAlarm?.type === 'consumption' ? 20 : 22 }}>
                        {tempAlarm?.message &&
                            <p>
                                {`${intl.formatMessage({ id: 'Message' })}: ${segData.page4.text[0]}`}
                                <br />
                                {`${intl.formatMessage({ id: 'Max Alarms' })}: ${segData.page4.text[1]}`}
                                <br />
                                {`${intl.formatMessage({ id: 'Timeframe' })}: ${segData.page4.text[2]}`}
                                <br />
                                {`${intl.formatMessage({ id: 'Date Range' })}: ${segData.page4.text[3]}`}
                            </p>
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AlarmSetProgressBar